import React from 'react';
import { FormattedMessage } from 'react-intl';

import EmptyStateIcon from './empty-state.svg?react';
import { EmptyData, EmptyMessage } from './EmptyState.style';

type Props = {
    emptyMessageId: string;
    emptyMessageValues?: Record<string, string | number>;
    icon?: React.ReactNode;
    size?: 'large' | 'medium';
};

export const EmptyState: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
    emptyMessageId,
    emptyMessageValues,
    icon,
    size = 'large',
    children,
    ...othersProps
}) => {
    const [width, height] = size === 'large' ? [97, 125] : [62, 80];
    return (
        <EmptyData {...othersProps}>
            {icon ?? <EmptyStateIcon width={width} height={height} role="img" />}
            <EmptyMessage>
                <FormattedMessage id={emptyMessageId} values={emptyMessageValues} />
            </EmptyMessage>
            {children}
        </EmptyData>
    );
};
